import { render, staticRenderFns } from "./NoProjectsYet.vue?vue&type=template&id=514bba47&scoped=true&"
import script from "./NoProjectsYet.vue?vue&type=script&lang=js&"
export * from "./NoProjectsYet.vue?vue&type=script&lang=js&"
import style0 from "./NoProjectsYet.vue?vue&type=style&index=0&id=514bba47&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514bba47",
  null
  
)

export default component.exports